import React, { useState } from "react";
import { object, number } from "prop-types";
import { Subheadline } from "@quintype/arrow";

import StoryElements from "../story-elements";
import CardImage from "../../atoms/cardimage";
import AuthorAndTimeStamp from "../story-header/author-and-timestamp";

import Resizer from "../story-header/resizer";
import FollowUs from "../story-header/follow-us";
import { SvgIconHandler } from "../../atoms/svg-icon-hadler";
import SocialMediaShare from "../../molecules/social-media-share";

import StorySideBar from "../story-sidebar";

import "./exclusive.m.css";
import { get } from "lodash";

const DHExclusiveStoryTemplate = ({ story, index, aspectRatio, imageType }) => {
  const customKicker = get(story, ["metadata", "story-attributes", "customkicker"], "");

  const [showSharingOptions, setShowSharingOptions] = useState(false);
  const sharingHandler = () => {
    setShowSharingOptions(!showSharingOptions);
  };
  return (
    <>
      <div styleName="wrapper">
        <div>
          <div styleName="header-content">
            <CardImage
              story={story}
              aspectRatio={aspectRatio}
              imageType={imageType}
              renderedWidth={720}
              widths={[700]}
              showVideoIcon={true}
            />
            <div styleName="headline-wrapper">
              {customKicker.length > 0 ? <div styleName="custom-kicker">{customKicker}</div> : null}
              <h1>{story.headline}</h1>
              <Subheadline lineClamp={10} story={story} clazzName="sub-headline" />
            </div>
            <div styleName="exclusive-author-wrapper">
              <AuthorAndTimeStamp story={story} isPVExclusive={true} />
              <div styleName="follow-resizer">
                <FollowUs />
                <div styleName="share">
                  <button onClick={sharingHandler}>
                    <SvgIconHandler type="blackshare" height="32px" width="32px" />
                  </button>
                  <div styleName="share-options">{showSharingOptions && <SocialMediaShare story={story} />}</div>
                </div>
                <Resizer story={story} />
              </div>
            </div>
          </div>
          <div styleName="sub-content">
            <div styleName="story-content">
              <div styleName="content">
                <StoryElements story={story} cards={story.cards} index={index} />
              </div>
            </div>
            <div className="hide-mobile side-story-section">
              <StorySideBar index={index} story={story} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

DHExclusiveStoryTemplate.propTypes = {
  story: object,
  index: number
};

DHExclusiveStoryTemplate.defaultProps = {
  aspectRatio: [16, 9],
  imageType: "image16x9"
};

const ExclusiveStory = (props) => {
  return <DHExclusiveStoryTemplate story={props.story} index={props.index} />;
};

ExclusiveStory.propTypes = {
  story: object,
  index: number
};

export default ExclusiveStory;
